import { createStore, applyMiddleware, compose } from 'redux'

import createSagaMiddleware from 'redux-saga'

import rootReducer from './reducer'
import rootSaga from './saga'

export default (initialState = {}) => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const sagaMiddleware = createSagaMiddleware()

  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware))

  const store = createStore(rootReducer, initialState, middleware)

  sagaMiddleware.run(rootSaga)

  return { store }
}



// WEBPACK FOOTER //
// ./src/redux/create.js